import * as Config from './config';
import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from "./vendor/router-ROUTER_TARGET";

import Library from './components/library/custom/-APP_TARGET/Library';
import CustomWrapper from './components/library/custom/-APP_TARGET/CustomWrapper';
import APILinkWrapper from './components/APILinkWrapper';
import LogWrapper from './components/LogWrapper';
import RejectWrapper from './components/RejectWrapper';
import ReplayTracksWrapper from './components/ReplayTracksWrapper';
import ErrorModal from './components/ErrorModalV2';
import ToastWrapper from './components/library/toast/ToastWrapper';
import SplashWrapper from './components/library/splash/SplashWrapper';
import Player from './components/library/player/Player';
import BannerNoChrome from './components/library/browser/BannerNoChrome';

/* Features Mods - Player <==> Library */
import CustomRoot from './components/library/custom/-APP_TARGET/CustomRoot';

// The State App Management
import { Provider } from "react-redux";
import store from "./store/index";

import {
  setBackend,
  setSplashError
} from "./actions/index";

const axios = require('axios');

// This component has to be link to a player ref (id)
class LRoot extends CustomRoot {
  state = {
    configuration: this.props.configuration || null, // Custom Config From Project
    playerSrcHTML: this.props.playerSrcHTML,
    playerSrcCss: this.props.playerSrcCss,
    playerSrcJSCore: this.props.playerSrcJSCore || null,
    playerSrcJSAPI: this.props.playerSrcJSAPI,
    playerSrcJSBridge: this.props.playerSrcJSBridge,
    playerSrcCssCustom: this.props.playerSrcCssCustom,
    playerIDRef: this.props.playerIDRef || 'player-default', // The link between to the player and the library
    playerHTML: null,
    jsCoreLoaded: false,
    jsAPILoaded: false,
    jsBridgeLoaded: false,
    maxWidth: window.innerWidth, // Max Width Library Container
    maxHeight: window.innerHeight, // Max Height Library + Player
    playerCoordinates: {}, // Reference to position the library elements
    fullHeight: true,
    rejectInfo: null,
    hasError: false,
    oError: null,
    isShrink: false,
    backend: 'touch' // Drag & Drop - Optimisation, (basic => `html5`)
  };

  componentDidMount() {
    // V1 - Default Player
    this.initPlayer();

    store.dispatch(setBackend(this.state.backend));
    this.overWriteConfig(this.state.configuration);
  }

  async initPlayer() {
    let lock = false;
    if (this.state.playerSrcHTML) {
      const head = document.getElementsByTagName('head')[0];

      if (this.state.playerSrcCssCustom) {
        const body = document.getElementsByTagName('body')[0];
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `${window.location.origin}/${this.state.playerSrcCssCustom}`;
        body.append(link);
      }

      if (this.state.playerSrcCss) {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `${window.location.origin}/${this.state.playerSrcCss}`;
        head.prepend(link);
      }

      // Entrypoint for the player
      let html = await axios.get(`${window.location.origin}/${this.state.playerSrcHTML}`)
        .then( res => res.data )
        .catch( e => {
          console.log('Warning: FAIL LOADING PLAYER HTML');
          lock = true;
          this.setState({ jsCoreLoaded: true, jsAPILoaded: true, jsBridgeLoaded: true })
          store.dispatch(setSplashError({ title: 'Player HTML Config Error', message: 'It seems there is a loading problem with the HTML' }));
          return `<div id="${this.state.playerIDRef}"></div>`;
        } )

      this.setState({ playerHTML: html }, () => {
        if (!lock) {
          if (this.state.playerSrcJSCore) {
            let script = document.createElement('script');
            script.src = `${window.location.origin}/${this.state.playerSrcJSCore}`;
            script.onload = () => {
              if (!window.core_player_get) {
                store.dispatch(setSplashError({ title: 'Config Error', message: 'It seems there is a loading problem with the YouDJ core' }));
              }
              this.setState({ jsCoreLoaded: true })
              if (this.state.playerSrcJSAPI) {
                let script = document.createElement('script');
                script.src = `${window.location.origin}/${this.state.playerSrcJSAPI}`;
                script.onload = () => {
                  if (!window['YouDJ'].init || !window['YouDJ']) {
                    store.dispatch(setSplashError({ title: 'YouDJ API Error', message: 'Need the `YouDJ` Object and the required method `init`' }));
                  }
                  this.setState({ jsAPILoaded: true })
                  if (this.state.playerSrcJSBridge) {
                    let script = document.createElement('script');
                    script.src = `${window.location.origin}/${this.state.playerSrcJSBridge}`;
                    script.onload = () => {
                      if (!window['window_resize']) { console.error('Bridge Error - Need the required method `window_resize`'); }
                      this.setState({ jsBridgeLoaded: true })
                    }
                    head.appendChild(script);
                  } else {
                    store.dispatch(setSplashError({ title: 'Config Error', message: 'The player need to load a bridge with the parameter `playerSrcJSBridge`' }));
                    this.setState({ jsBridgeLoaded: true })
                  }
                }
                head.appendChild(script);
              } else {
                store.dispatch(setSplashError({ title: 'Config Error', message: 'The player need to load the API with the parameter `playerSrcJSAPI`' }));
                this.setState({ jsAPILoaded: true, jsBridgeLoaded: true })
              }
            }
            head.appendChild(script);
          } else {
            store.dispatch(setSplashError({ title: 'Config Error', message: 'The player need to load the core with the parameter `playerSrcJSCore`' }));
            this.setState({ jsCoreLoaded: true, jsAPILoaded: true, jsBridgeLoaded: true })
          }
        }
        lock = true;
      });
    } else { // NO LOADING PLAYER
      this.setState({ jsCoreLoaded: true, jsAPILoaded: true, jsBridgeLoaded: true, playerHTML: `<div id="${this.state.playerIDRef}"></div>` })
      // <div id="${this.state.playerIDRef}" style="display: flex; justify-content: center; position:absolute; width: calc(100% - 240px); left:240px; top:0px; height:0px;"></div>
    }
  }

  overWriteConfig(config) {
    if (config) { // For Packages
      Object.keys(config).forEach( key => {
        if (Config[`SET_${key}`]) {
          Config[`SET_${key}`](config[key]);
        }
      });
    }
    if (window.env) { // For Docker
      Object.keys(window.env).forEach( key => {
        if (Config[`SET_${key}`] && !window.env[key].includes(key) && window.env[key] !== '') {
          Config[`SET_${key}`](window.env[key]);
        }
      });
    }
  }

  // Catch Global Error
  static getDerivedStateFromError(error) {
    return { hasError: true, oError: error };
  }

  /*** Public Methods ***/

  hasSplashScreen() { try { return store.getState().splashState; } catch(e) { return false; } }
  releaseDate() { return Config.RELEASE_DATE }
  releaseVersion() { return Config.RELEASE_VERSION }
  ydCoreVersion() { return Config.YOUDJ_CORE_VERSION }
  getConfig() {
    return {
      API_URL: Config.API_URL,
      API_CLIENT_ID: Config.API_CLIENT_ID,
      API_IDENTITY_URL: Config.API_IDENTITY_URL,
      API_SEARCH_URL: Config.API_SEARCH_URL,
      API_DJAPP_URL: Config.API_DJAPP_URL,
      AUTH_DJAPP_URL: Config.AUTH_DJAPP_URL,
      PM_URL: Config.PM_URL,
      PM_PATH: Config.PM_PATH ,
    }
  }

  /* Layout */

  resize(maxWidth = null, maxHeight = null) {
    const player = document.getElementById(this.state.playerIDRef);
    if (player) {
      let playerCoordinates = player.getBoundingClientRect();
      playerCoordinates.playerID = this.state.playerIDRef;
      playerCoordinates.height = (window.window_zoom < 1) ? ((window.compact_mode_enable) ? Config.COMPACT_HEIGHT_PLAYER : Config.MAX_HEIGHT_PLAYER) : playerCoordinates.height; // HOTFIX - ZOOM
      maxWidth = maxWidth ? maxWidth : ((playerCoordinates.height > 0 && window.innerWidth > Config.MAX_WIDTH) ? Config.MAX_WIDTH : window.innerWidth);
      maxHeight = maxHeight ? maxHeight : Math.floor(window.innerHeight - playerCoordinates.bottom);
      this.setState({maxWidth, maxHeight, playerCoordinates});

      //Vertical mode will focus on library management
      if (window.innerHeight > window.innerWidth && window.compact_toggle && !window.compact_mode_enable && this.state.isShrink === false) {
        window.compact_toggle();
        this.setState({ isShrink: true });
      }
      if (window.innerWidth > window.innerHeight && window.compact_toggle && window.compact_mode_enable && this.state.isShrink) {
        window.compact_toggle();
        this.setState({ isShrink: false });
      }
    } else {
      store.dispatch(setSplashError({ title: 'Player Config Error', message: `This player Ref '${this.state.playerIDRef}' does not exist. The library needs a valid ref.` }));
    }
  }
  fullHeight(state = false) {
    // FALSE = NORMAL: Player on top full width (same AUTOMIX COVERFLOW) + Library Bottom
    // TRUE = Playlists Panel Full Height on left
    this.setState({ fullHeight: state });
  }

  /* Player Call */

  reject_song(pid, trackID = null) { // Player can reject some tracks
    this.setState({ rejectInfo: { pid, trackID } });
  }

  /* RENDERING */

  render() {
    const {
      maxWidth, maxHeight, fullHeight, playerCoordinates,
      rejectInfo, hasError, oError, backend,
      playerHTML, jsCoreLoaded, jsAPILoaded, jsBridgeLoaded, playerSrcHTML
     } = this.state;

    return !hasError  ? (
      <Router >
        <Provider store={store}>
          { (playerHTML && jsCoreLoaded  && jsAPILoaded && jsBridgeLoaded ) && (
            <>
              <SplashWrapper />
              <div id="alpha3" style={{display: 'flex', justifyContent: 'center', position: 'absolute', width: '100%', minWidth: 1410, top: 0, height: 'calc(100% - 0px)', background: 'transparent', zIndex:30}}>
            		<div id="DJAPPMM_container" style={{position: 'relative', width: '100%', height: '100%' /*, maxWidth: 1410*/}}>
                  <div id="custom_drag_layer"></div>
                  <BannerNoChrome />
                  <Player html={playerHTML} />
                  <APILinkWrapper />
                  <LogWrapper />
                  <ReplayTracksWrapper />
                  <RejectWrapper data={rejectInfo} />
                  <ToastWrapper />
                  <CustomWrapper hasPlayer={!!playerSrcHTML} />
                  <Library
                    backend={backend}
                    maxWidth={maxWidth} maxHeight={maxHeight} fullHeight={fullHeight}
                    playerCoordinates={playerCoordinates}
                    style={{
                      width: maxWidth,
                      height: maxHeight,
                      background: `transparent`,
                    }}
                  />
                </div>
              </div>
            </>
          ) }
        </Provider>
      </Router>
    ) : (
      <ErrorModal error={oError} />
    )
  }
}

LRoot.propTypes = {
  configuration: PropTypes.any,
  playerSrcHTML:PropTypes.string,
  playerSrcCss:PropTypes.string,
  playerSrcJSCore: PropTypes.string,
  playerSrcJSAPI: PropTypes.string,
  playerSrcJSBridge: PropTypes.string,
  playerSrcCssCustom: PropTypes.string,
  playerIDRef: PropTypes.string
}

export default LRoot;
